<div class="dialog-overlay" (click)="onOverlayClick($event)">
  <div class="dialog-card">

    <!-- Header -->
    <div class="dialog-header">
      <div class="icon-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      </div>
      <div class="header-text">
        <span class="dialog-title">{{ title }}</span>
      </div>
      <button *ngIf="mode === 'rules'" class="close-icon-btn" (click)="onClose()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="#344054" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Subtitle -->
    <p class="dialog-subtitle">{{ subtitle }}</p>

    <!-- Info Banner -->
    <div class="info-banner">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="#0A84FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <span>{{ infoBannerText }}</span>
    </div>

    <!-- Rule 1 -->
    <div class="rule-card">
      <div class="rule-number">1</div>
      <p class="rule-text">Content shared within this group cannot be shared outside the group. A user can still set it as private.</p>
    </div>

    <!-- Rule 2 -->
    <div class="rule-card">
      <div class="rule-number">2</div>
      <p class="rule-text">If a user shares content outside this group while this feature is enabled, the user will lose access to this group's data.</p>
    </div>

    <!-- Actions -->
    <div class="dialog-actions" *ngIf="mode === 'agreement'">
      <button class="btn-disagree" (click)="onDisagree()">Disagree</button>
      <button class="btn-agree" (click)="onAgree()">Agree</button>
    </div>

  </div>
</div>
